import { render, staticRenderFns } from "./BasicSetting.vue?vue&type=template&id=3b4f887a&scoped=true&"
import script from "./BasicSetting.vue?vue&type=script&lang=js&"
export * from "./BasicSetting.vue?vue&type=script&lang=js&"
import style0 from "./BasicSetting.vue?vue&type=style&index=0&id=3b4f887a&prod&lang=scss&scoped=true&"
import style1 from "./BasicSetting.vue?vue&type=style&index=1&id=3b4f887a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4f887a",
  null
  
)

export default component.exports